import { isModuleId, resolveEnabledModules } from '@app/shared';
import type { WebModule } from './types.ts';
import { calendarModule } from '../features/calendar/module.ts';
import { listsModule } from '../features/lists/module.ts';
import { tasksModule } from '../features/tasks/module.ts';
import { mealsModule } from '../features/meals/module.ts';
import { photosModule } from '../features/photos/module.ts';
import { vaultModule } from '../features/vault/module.ts';
import { petsModule } from '../features/pets/module.ts';
import { maintenanceModule } from '../features/maintenance/module.ts';
import { goalsModule } from '../features/goals/module.ts';
import { emergencyModule } from '../features/emergency/module.ts';
import { memoriesModule } from '../features/memories/module.ts';
import { boardModule } from '../features/board/module.ts';

/**
 * Static list of feature modules. To add a feature, add its module here; to
 * turn an optional one off, list it in the server's DISABLED_MODULES — the
 * server tells the client which modules are disabled at sign-in.
 */
const ALL_MODULES: WebModule[] = [
  calendarModule,
  listsModule,
  tasksModule,
  mealsModule,
  photosModule,
  memoriesModule,
  boardModule,
  vaultModule,
  petsModule,
  maintenanceModule,
  goalsModule,
  emergencyModule,
];

export function enabledModules(disabled: readonly string[]): WebModule[] {
  const { enabled } = resolveEnabledModules(disabled);
  return ALL_MODULES.filter((m) => !isModuleId(m.id) || enabled.has(m.id));
}

export { ALL_MODULES };
